export default __webpack_public_path__ + "static/media/404.d45160e3.svg";